module.exports = __webpack_public_path__ + "img/individual.cfac7ea1.svg";